"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _reselect = require("reselect");

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var _getNestedPropertiesAsStrings = _interopRequireDefault(require("redux-less/utils/getNestedPropertiesAsStrings"));

var _default = function _default(_ref) {
  var selector = _ref.selector,
      properties = _ref.properties;
  return properties.reduce(function (acc, property) {
    if (typeof property === "string") {
      acc[property] = (0, _reselect.createSelector)([selector], function (selected) {
        return selected.get(property);
      });
    } else if ((0, _typeof2.default)(property) === "object") {
      if (property.type === _PropertyTypes.default.NESTED) {
        var nestedPropertiesAsStrings = (0, _getNestedPropertiesAsStrings.default)(property);
        nestedPropertiesAsStrings.forEach(function (prop) {
          acc[prop] = (0, _reselect.createSelector)([selector], function (selected) {
            return selected.getIn(prop.split("/"));
          });
        });
      } else {
        acc[property.key] = (0, _reselect.createSelector)([selector], function (selected) {
          return selected.get(property.key);
        });
      }
    }

    return acc;
  }, {});
};

exports.default = _default;
module.exports = exports.default;